import React, { Component } from 'react'
import SystemLabelMasterCollection from 'collections/system_label_master_collection'
import CompanyModel from 'models/company_model'

class SelectPrice extends Component {

  handleChangeStart = (e) => {
    this.props.actions.changeSelectPriceStart({
      selectPriceStart: e.target.value,
    })
  }

  handleChangeFinish = (e) => {
    this.props.actions.changeSelectPriceFinish({
      selectPriceFinish: e.target.value,
    })
  }

  render() {
    const { payload } = this.props.systemLabelMastersApi
    if (!payload) {
      return null
    }
    const systemLabelMasterCollection = new SystemLabelMasterCollection(payload)
    const { payload: siteItemsPayload } = this.props.siteItemsApi
    if (!siteItemsPayload) {
      return null
    }
    const { company } = siteItemsPayload
    const companyModel = new CompanyModel(company);
    if (!companyModel.isIdExists()) {  // loggedin?
      return null
    }
    return (
      <div className='searchArea__item'>
        <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.HOPE_PRICE}</h3>
        <div className='searchArea__item__half searchArea__item__inner'>
          <p className='selectWrap'>
            <select
              className='select'
              value={this.props.selectPriceStart}
              onChange={this.handleChangeStart}
            >
              <option value="">{TRUCKERS.LANG.ITEM.LIST_SEARCH.LOWER}</option>
              {
                systemLabelMasterCollection.getValueList('item', 'select_price').map(i => {
                  return <option key={i.get('label_key')} value={i.get('label_key')}>{i.getValueI18n()}</option>
                })
              }
            </select>
          </p>
          <p>〜</p>
          <p className='selectWrap'>
            <select
              className='select'
              value={this.props.selectPriceFinish}
              onChange={this.handleChangeFinish}
            >
              <option value="">{TRUCKERS.LANG.ITEM.LIST_SEARCH.UPPER}</option>
              {
                systemLabelMasterCollection.getValueList('item', 'select_price').map(i => {
                  return <option key={i.get('label_key')} value={i.get('label_key')}>{i.getValueI18n()}</option>
                })
              }
            </select>
          </p>
        </div>
      </div>
    )
  }
}

export default SelectPrice
